<!-- 登录日志 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">登录日志</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
		<div class="screen-box">
			<div class="screen-label">投放日期</div>
			<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false" 
			:locale="locale" 
			:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
		</div>
		
		<div class="screen-box">
			<div class="screen-label">投手</div>
			<a-select
				show-search
				allowClear
			    style="min-width: 200px"
			    placeholder="请选择投手"
			    @change="handleChangeA"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option v-for="(value,key) in filterList" :key="key" :value="key">
			      {{value}}
			    </a-select-option>
			</a-select>
			
		</div>
		
		<a-button class="screen-box" @click="searchButton" type="primary">搜索</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<!-- ID -->
			<div class="table-td-cell" :style="{'width':rableTitle[0].width + 'px'}">
				{{item.id}}
			</div>
			<!-- 用户名 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[1].width + 'px'}">
				{{item.user_name}}
			</div>
			<!-- IP -->
			<div  class="table-td-cell" :style="{'width':rableTitle[2].width + 'px'}">
				{{item.ip}}
			</div>
			<!-- 省 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[3].width + 'px'}">
				{{item.province}}
			</div>
			<!-- 市 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[4].width + 'px'}">
				{{item.city}}
			</div>
			<!-- 运营商 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[5].width + 'px'}">
				{{item.county}}
			</div>
			<!-- 登录时间 -->
			<div  class="table-td-cell" :style="{'width':rableTitle[6].width + 'px'}">
				{{item.created_at}}
			</div>
		</div>
		
		
		<div v-show="tableShowData.length === 0" style="text-align: center;text-align:center;padding: 80px 0 50px;" :style="{'width': table_scroll_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
		</div>
		
	</div>
	
	<!-- 分页 -->
	<div :style="{'width': table_scroll_width + 'px',}" style="text-align: center;margin-top: 30px;">
		
		<a-pagination v-model="r_page" :pageSize="r_limit" :total="table_total" @change="paginationChange" hideOnSinglePage />
		
	</div>
	
	<!-- 加载中 -->
	<div class="loading-box" v-show="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';

import { getLoginLog, logSelectUser } from '@/request/api'	
export default {
	name: 'loginLog_',
	components: {
		
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-06-12',
			endTime: '2022-06-23',
			
			r_op_id:"",
			filterList: {},
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"序号", width:100, type:"id", }, // sort_status: 0为默认，1为下面的三角高亮，2位上面的三角高亮
				{title:"用户名", width:160, type:"user_name", },
				{title:"IP", width:180, type:"ip", },
				{title:"省", width:120, type:"province", },
				{title:"市", width:120, type:"city", },
				{title:"运营商", width:120, type:"county", },
				{title:"登录时间", width:200, type:"created_at", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			search_button_loading: false,
			
			r_page: 1, // 页数
			r_limit: 20, // 每页多少条
			table_total: 0, // 表格内容总数
		}
	},
	mounted() {
		let that = this
		that.search_button_loading = true
		// 获取14天前日期
		let date1 = new Date(new Date().getTime() - 1209600000);
		let month1
		if(date1.getMonth() + 1 < 10){
			month1 = '0' + (date1.getMonth() + 1)
		}
		else {
			month1 = date1.getMonth() + 1
		}
		let day1
		if(date1.getDate() < 10){
			day1 = "0" + date1.getDate()
		}
		else {
			day1 = date1.getDate()
		}
		that.startTime = date1.getFullYear() + "-" + month1 + "-" + day1;
		
		// 获取当前日期
		let date2 = new Date();
		let month2
		if(date2.getMonth() + 1 < 10){
			month2 = '0' + (date2.getMonth() + 1)
		}
		else {
			month2 = date2.getMonth() + 1
		}
		let day2
		if(date2.getDate() < 10){
			day2 = "0" + date2.getDate()
		}
		else {
			day2 = date2.getDate()
		}
		that.endTime = date2.getFullYear() + "-" + month2 + "-" + day2;
		
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		that.table_scroll_width = nn + 30
		
		// 获取搜索条件
		logSelectUser().then(res=>{
			console.log('获取搜索条件',res.data.data)
			
			that.filterList = res.data.data.list
		})
		
		that.searchButton()
	},
	methods: {
		// 日期选择
		onChangeDate(date, dateString) {
			// console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 投手
		
		// handleChangeAA(value) {
		//       console.log(`selected ${value}`);
		//     },
		handleChangeA(value) {
			console.log(value)
			this.r_op_id = value // 记录选择的人的id
		    console.log(`selected ${value}`);
		},
		// 投手结束
		
		// 搜索
		searchButton(){
			let that = this
			that.search_button_loading = true
			getLoginLog({
				start_date: that.startTime.replace(/-/g, ''),
				end_date: that.endTime.replace(/-/g, ''),
				user_id: that.r_op_id,
				page: that.r_page
			}).then(res=>{
				console.log("获取登录日志列表",res)
				that.search_button_loading = false
				if(res.data.code === 0 || res.data.code === 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code === 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`其他错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			that.searchButton()
			
		},
	}
}	
</script>

<style scoped>

</style>